<template>
    <div class="dataAny1" v-if="isshow">
        <div class="filters">
            <div class="add"></div>
            <div class="search">
                <el-button @click="handleExport">导出</el-button>
            </div>
        </div>
        <div class="result-list btn-operate-list">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="name" label="姓名" class-name="title">
                    <template slot-scope="scope">
                        <div class="headImg">
                            <img :src="scope.row.customericonurl" alt="">
                            <span>{{scope.row.customername}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="来源" class-name="center">
                    <template slot-scope="scope">
                      <span>{{scope.row.customersource==1?'PC':(scope.row.customersource==2?'H5':'小程序')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="totalstudytimes" label="累计学习时长" class-name="center" :render-header="renderHeader"></el-table-column>
                <el-table-column prop="validstudytimes" label="有效学习时长" class-name="center"></el-table-column>
                <el-table-column prop="percentage" label="学习进度" class-name="center" :render-header="renderHeader"></el-table-column>
                <el-table-column prop="starttime" label="首次学习时间" class-name="center"></el-table-column>
                <el-table-column prop="endtime" label="完成时间" class-name="center"></el-table-column>
            </el-table>
            <page :total="total" @getList="_getList" ref="page"></page>
        </div>
    </div>
</template>
<script>
    import {getCoursestudyinfoByCustomer,getExportCoursestudyinfo} from 'api/curriculumApi'
    import Page from 'base/page/page'
    import {dateFormat} from 'common/js/tools'
    import {mapGetters, mapActions} from 'vuex'
    export default {
        name: "dataAny1",
        data(){
            return{
                courseid:this.$route.query.innerid?this.$route.query.innerid:'',
                tableData:[],
                total: 0,
                courseinfo:{},
                isshow:false, // 是否显示页面
            }
        },
        mounted(){
           this._getList()
        },
        methods:{
            // 表头提示
            renderHeader (h,{column}) {
                return h(
                    'div', [
                        h('span', column.label),
                        h('el-tooltip', {
                            props: {
                                effect: 'dark',
                                content: column.label=='学习进度'?'最大的播放时间点/总时长，最大播放时间点包括拖拽操作':'用户在课程中播放视频的时长',
                                placement: 'top',
                            },
                        },
                        [h('i', {
                            class: 'el-icon-warning',
                            style: 'color:#999;margin-left:5px;cursor:pointer;'
                        })],
                        {content: column.label=='学习进度'?'最大的播放时间点/总时长，最大播放时间点包括拖拽操作':'用户在课程中播放视频的时长'})
                    ]
                );
            },
            _getList(){
                this.setLoading(true)
                let param={
                    courseid:this.courseid
                }
                getCoursestudyinfoByCustomer({
                    data: Object.assign({}, param, this.page),
                    success: data => {
                        this.setLoading(false)
                        this.isshow=true
                        if(this.page.page===1){
                            this.courseinfo=data.data.courseinfo
                        }
                        this.tableData = data.data.content
                        this.total = data.data.pageinfo.rowCount
                        this.$emit('getCourInfo',this.courseinfo)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            // 导出
            handleExport(){
                this.setLoading(true)
                getExportCoursestudyinfo({
                    data: {courseid: this.courseid},
                    success: data => {
                        let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                        let fileName = '学员列表' + dateFormat(new Date()) + '.xls'
                        if (window.navigator.msSaveOrOpenBlob) {
                            navigator.msSaveBlob(blob, fileName)
                        } else {
                            var link = document.createElement('a')
                            link.href = window.URL.createObjectURL(blob)
                            link.download = fileName
                            link.click() // 释放内存
                            window.URL.revokeObjectURL(link.href)
                        }
                        this.setLoading(false)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            ...mapActions([
                'setLoading',
            ])
        },
        computed: {
            ...mapGetters([
                'page'
            ])
        },
        components:{
            Page
        }
    }
</script>

<style lang="scss">
    .filters{
        margin-bottom: 20px;
    }
    .result-list{
        .headImg{
            display: flex;
            align-items: center;
            img{
                width: 60px;
                height: 60px;
                border-radius: 50%;
                margin-right: 10px;
            }
        }
        .el-table{
            .title{
                .cell{
                    padding: 0;
                    margin-left: 5px;
                }
            }
            .center{
                .cell{
                    text-align: center;
                    span{
                        font-weight: bold;
                    }
                }
            }
        }
    }
</style>
